import {useState} from 'react';

import {SavedSearchRequestSortField} from 'src/openapi/admin/models/SavedSearchRequest';
import {SortDirection as OpenApiSortDirection} from 'src/openapi/admin/models/SortDirection';

import {SortDirections} from '@pb/kit-component-sort-header';

import {SortDirectionType} from '../../../typedef';


type UseSortProps = {
    onSortChange?: (field: SavedSearchRequestSortField, direction: OpenApiSortDirection) => void,
};

export const useSort = ({onSortChange}: UseSortProps) => {
    const [typeSortDirection, setTypeSortDirection] = useState<SortDirectionType>(null);
    const [dateCreatedSortDirection, setDateCreatedSortDirection] = useState<SortDirectionType>(null);
    const [lastRunSortDirection, setLastRunSortDirection] = useState<SortDirectionType>(null);
    const [lastSharedSortDirection, setLastSharedSortDirection] = useState<SortDirectionType>(null);
    const [lastSortedColumn, setLastSortedColumn] = useState<string | null>(null);

    const handleSort = (columnName: string, direction: SortDirectionType) => {
        let sortField: SavedSearchRequestSortField;
        let sortDirection: OpenApiSortDirection;

        if (direction === SortDirections.ASC) {
            sortDirection = OpenApiSortDirection.ASC;
        } else if (direction === SortDirections.DESC) {
            sortDirection = OpenApiSortDirection.DESC;
        } else {
            return;
        }

        setLastSortedColumn(columnName);

        switch (columnName) {
            case 'type':
                setTypeSortDirection(direction);
                sortField = SavedSearchRequestSortField.SEARCH_TYPE;
                break;
            case 'dateCreated':
                setDateCreatedSortDirection(direction);
                sortField = SavedSearchRequestSortField.CREATE_DATE;
                break;
            case 'lastRun':
                setLastRunSortDirection(direction);
                sortField = SavedSearchRequestSortField.LAST_RUN_DATE;
                break;
            case 'lastShared':
                setLastSharedSortDirection(direction);
                sortField = SavedSearchRequestSortField.LAST_SHARED_DATE;
                break;
            default:
                return;
        }
        onSortChange?.(sortField, sortDirection);
    };

    return {
        typeSortDirection,
        dateCreatedSortDirection,
        lastRunSortDirection,
        lastSharedSortDirection,
        lastSortedColumn,
        handleSort,
    };
};
